var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBarcodeMatchGreen(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 29,
    viewBox: "0 0 32 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillOpacity: 0.87
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H1.919V23.395H0zM3.838 0H7.676V23.395H3.838zM9.596 0H11.515V23.395H9.596zM15.353 0H17.272V23.395H15.353zM21.11 0H23.029V23.395H21.11zM24.949 0H26.868000000000002V23.395H24.949z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.515 7.798)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.596,
    cy: 9.748,
    fill: "#FFF",
    rx: 9.596,
    ry: 9.748
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#68AC58",
    fillRule: "nonzero",
    d: "M7.98 15.263l9.015-9.158-1.418-1.49-7.596 7.742-3.558-3.64-1.418 1.442 4.976 5.104zM10 0c1.827 0 3.518.464 5.072 1.392 1.507.88 2.692 2.084 3.558 3.614.913 1.58 1.37 3.297 1.37 5.153 0 1.856-.457 3.573-1.37 5.152-.866 1.53-2.051 2.735-3.558 3.615-1.554.927-3.245 1.391-5.072 1.391s-3.518-.464-5.072-1.391c-1.507-.896-2.692-2.109-3.558-3.64C.457 13.709 0 11.999 0 10.16c0-1.84.457-3.55 1.37-5.128.882-1.53 2.076-2.744 3.582-3.64C6.506.465 8.189 0 10 0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarcodeMatchGreen);
export default __webpack_public_path__ + "static/media/barcode_match_green.71bddb32369919d7099ae030b3f0bd44.svg";
export { ForwardRef as ReactComponent };